import { Component, OnInit } from '@angular/core';
import { Constants } from '../../_utils/Constants';
import { $DBManagerService } from '../../_helpers/DB/DBManager.service';
import { $BroadcastManagerService } from '../../_helpers/BroadcastManager.service';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { APILoginService } from '../../_root/Trai_module/_services/login/API-login';
import { APIEntityService } from '../../_root/Trai_module/_services/entity/API-entity';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'r-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit { 
 public userRole: any;
 public user: any;
  public loginFlag: boolean;
 public mobileNumber: any;
 public welcomeName: any;
 public tataId: any;
 public entityID: any;
 public orgName: any;
 public last_login: any;
 public entity_expiry: any;
 public paymentFlag: any;
 public refNo: any;
 public name: boolean = false;
 balancedays: any;
 expiryDays: any;
  hasCertExpired: boolean = false;

  constructor(
    private evt: $BroadcastManagerService,
    private db: $DBManagerService,  
    private router: Router,
    location: PlatformLocation,
    private log: APILoginService,
    private es: APIEntityService,
    private datepipe: DatePipe
  ) {
		this.userRole = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
		this.welcomeName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME);
		this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
		this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
    this.mobileNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME); 
    this.entityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID); 
    this.orgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME); 
    this.last_login = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
    this.entity_expiry =this.datepipe.transform(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY), 'yyyy-MM-dd');
    // this.balancedays=this.db.get(Constants.SESSSION_STORAGE, Constants.PWDEXPBALANCEDAYS);
    this.balancedays= this.es.getpwdexpirydiffdays()
    this.expiryDays = this.es.getCertexpirydiffdays()
    this.hasCertExpired = this.es.getCertexpiryFlag()
    console.log("In Constructor   ", this.last_login, this.loginFlag, this.balancedays)
    //this.name = this.db.get(Constants.SESSSION_STORAGE, Constants.NAME); 
    // console.log(" NAME   ",this.name )

    
	}  



  ngOnInit() {
	
    this.userRole = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
    //console.log("INSID HEADR FLAG ",this.userRole);
    this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
    this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
    this.mobileNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);
    this.welcomeName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME);
    this.entityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID); 
    this.orgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME); 
    this.name = this.db.get(Constants.SESSSION_STORAGE, Constants.NAME);
    this.last_login = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
    this.entity_expiry =this.datepipe.transform(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY), 'yyyy-MM-dd');
    
    //this.balancedays=this.db.get(Constants.SESSSION_STORAGE, Constants.PWDEXPBALANCEDAYS);
    this.balancedays= this.es.getpwdexpirydiffdays()
    this.expiryDays = this.es.getCertexpirydiffdays()
    this.hasCertExpired = this.es.getCertexpiryFlag()
    console.log("------ng onitn-balance days----------",this.balancedays, this.loginFlag, this.entity_expiry)
    

    this.evt.getInstance()
      .subscribe(r => {
        if (r.click === 'LOGIN_EVENT_')
          this.name = this.db.get(Constants.SESSSION_STORAGE, Constants.NAME);

        // console.log("In EVENT NAME   init",this.name )
      })


	//console.log("welcomeName --",this.welcomeName);
  //  this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.RJIOUSER_NAME);
    this.evt.getInstance()
      .subscribe(r => {
        if (r.click === 'HEADER_EVENT_')
          this.userRole = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
          this.welcomeName = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CONTACTNAME);
          this.user = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_NAME);
          this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
          this.mobileNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.MOBILE_NO);
      this.tataId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      this.entityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID); 
      this.orgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME); 
        this.last_login = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
        this.entity_expiry =this.datepipe.transform(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_EXPIRY), 'yyyy-MM-dd');
        // this.last_login = this.db.get(Constants.SESSSION_STORAGE, Constants.LAST_LOGIN);
      this.balancedays= this.es.getpwdexpirydiffdays()
      this.expiryDays = this.es.getCertexpirydiffdays()
        this.hasCertExpired = this.es.getCertexpiryFlag()
        console.log("-------balance days----HDR EVENT------",this.balancedays,  this.entity_expiry)
		  //console.log("HEADER_EVENT_ this.userRole, this.welcomeName, this.user, this.loginFlag, this.mobileNumber, this.tataId", this.userRole, this.welcomeName, this.user, this.loginFlag, this.mobileNumber, this.tataId)  
      let Flag = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG);
      this.paymentFlag = atob(Flag)
      this.refNo = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN); 
      });
  }
  
  ispassword():boolean{
    return this.balancedays>0 && this.balancedays<=5;
  }
  
  isExpired():boolean {
    return this.expiryDays > 0 && this.expiryDays <= 30;
  }

  afterExpired():boolean {
    return this.hasCertExpired;
  }

  homeLinksChanging() {
    if (this.router.url === '/common-login') {
      this.router.navigateByUrl('/common-login')
     // console.log("common login");
    }
    else if (this.router.url === '/subscriber-login') {
      this.router.navigateByUrl('/subscriber-login')
      
      //console.log("subscriber login");
    }
    else if (this.router.url === '/') {
      this.router.navigateByUrl('/')
      
     // console.log("home page");
    }

    
      switch (this.userRole) {
        case 'Subscriber': this.router.navigateByUrl('/dnd-registration-details')
                          // this.homeLink="/dnd-registration-details";
                          break;
        case 'PE': this.router.navigateByUrl('/pending-consents')
                  //  this.homeLink="/pending-consents";
                   break;
        case 'TM': this.router.navigateByUrl('/scrubbing-summary')
                    // this.homeLink="/scrubbing-summary";
                   break;
        case 'Tata Employee': this.router.navigateByUrl('/dashboard-new')
                              // this.homeLink="/dashboar-new";
                              break;
        default: console.log("invalid selection")
      }
   
  }

  logOut() {
    var ID;
    console.log("logout");
    localStorage.removeItem('currentUser');
    if (this.userRole === 'Subscriber') {
      this.router.navigateByUrl('/subscriber-login')  
    }
    else {
      //this.router.navigateByUrl('/')  
      ID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      var URNorEntityID
      URNorEntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.URNORENTID);
      // this.db.set(Constants.SESSSION_STORAGE,Constants.ERR_MSG,"");
      // this.db.set(Constants.SESSSION_STORAGE, Constants.USER_ROLE,"");
      sessionStorage.removeItem("USER_ROLE")
      sessionStorage.removeItem("ERR_MSG")
      console.log("tURNorEntityID  ", URNorEntityID)
      if (this.userRole == "Tata Employee") {
        //URNorEntityID = "EntityID"
        URNorEntityID = "TTSL_ID"
      }
      else {

        if (URNorEntityID == "URN") {
          ID = this.db.get(Constants.SESSSION_STORAGE, Constants.URN);
        }
        else {
          console.log("else ")
          ID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
        }
      }
      console.log(ID, URNorEntityID)
      this.log.logOut(ID, URNorEntityID)
        .subscribe((r) => {
          console.log("r ", r)
          sessionStorage.clear()
          this.router.navigateByUrl('/')  
        })
    }

  }
 
}
